import {isDaumBlogDomain} from "../../utils/UriUtil";

export const graphConfig = {
  listeners: [],
  type: "serial",
  theme: "light",
  addClassNames: true,
  marginTop: 0,
  marginBottom: 25,
  marginRight: 0,
  marginLeft: 0,
  autoMargins: false,
  bezierX: 100,
  mouseWheelZoomEnabled: false,
  startDuration: 0.1,
  startEffect: "easeInSine",
  balloon: {
    drop: true,
    adjustBorderColor: true,
    borderAlpha: 0,
    color: "#000000",
    cornerRadius: 0,
    pointerWidth: 0,
    fillColor: "#FFFFFF",
    fillAlpha: 0
  },
  graphs: [
    {
      id: "lineChart",
      valueField: "count",
      lineThickness: 3,
      lineAlpha: 1,
      bulletSize: 9,
      fillAlphas: 0,
      lineColor: isDaumBlogDomain() ? "#1a9be4" : "#ff5544",
      customBulletField: "customBulletField",
      balloonText: '',
      balloonFunction: null
    },
  ],
  chartCursor: {
    oneBalloonOnly: true,
    cursorAlpha: 1,
    categoryBalloonEnabled: false,
    leaveCursor: true,
    zoomable: false,
    graphBulletSize: 1,
    cursorColor: "#e6e6e6",
    dashLength: 3
  },
  chartCursorSettings: {
    valueBalloonsEnabled: false,
    fullWidth: false,
    cursorAlpha: 0.1
  },
  categoryField: "timestamp",
  categoryAxis: {
    parseDataProviders: false,
    gridAlpha: 0,
  },
  valueAxes: [{
    strictMinMax: true,
    dashLength: 3,
    axisAlpha: 0.1,
    minimum: 0,
    stackType: "regular",
    labelsEnabled: false,
  }],
  dataProvider: []
};
